export const locale = {
    lang: 'en',
    data: {
        'PLANNINGOVERZICHT': {
            'FILTERAFDELING': 'Filter on a department',
            'FILTERTEXT': 'Filter on text'
        },
    }
};
